module.exports = __webpack_public_path__ + "img/ip-header-karten.4438df9b.svg";